import { ImageManagerWidget } from './ImageManagerWidget';
import { RadioWidget } from './RadioWidget';
import { SelectWidget } from './SelectWidget';
import { TextareaWidget } from './TextareaWidget';
import { RichTextWidget } from './RichTextWidget';

// menuBuilder and imageLinkManager are intentionally absent: their `ui:widget`
// values are intercepted by the ArrayField override in ../fields/ArrayField.tsx,
// which renders a field so per-item validation errors reach each row inline.
export const widgets = {
  TextareaWidget,
  SelectWidget,
  RadioWidget,
  imageManager: ImageManagerWidget,
  richText: RichTextWidget,
};
